export enum FeatureAnalysisAvailabilityFilterLevel {
  All = "All",
  Common = "Common",
  Differentiators = "Differentiators",
}
